
const getTabWidth = () => {
    return 350;
}

export default getTabWidth;